import { Variables, useGraphqlObjConfig } from "../graphql";
import { GqlObj } from "../graphql/types";
import { QueryKey } from "./types";

export const useQueryKey = <TVars extends Variables | undefined>(
  query: GqlObj,
  variables: TVars
): QueryKey<TVars> => {
  const { endpoint } = useGraphqlObjConfig(query);

  return [
    query.operationName,
    {
      query,
      variables,
      graphQLEndpoint: endpoint,
    },
  ];
};
